import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField,
} from "@mui/material";
import { toNum } from "./orderManagementUtils";

export default function NewArticleDialog({
    open,
    newArticle,
    newArticleErrors,
    onClose,
    onSave,
    onFieldChange,
}) {
    return (
        <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle>Artikel hinzufügen</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField
                        label="Artikelnummer"
                        value={newArticle.articleNumber}
                        fullWidth
                        InputProps={{ readOnly: true }}
                        helperText="Wird automatisch vergeben."
                        FormHelperTextProps={{ sx: { color: "text.secondary" } }}
                    />
                    <TextField
                        label="Name"
                        value={newArticle.name}
                        onChange={(event) => onFieldChange("name", event.target.value)}
                        fullWidth
                        required
                        error={Boolean(newArticleErrors.name)}
                        helperText={newArticleErrors.name || ""}
                    />
                    <TextField
                        label="Netto-Preis"
                        type="number"
                        value={newArticle.price}
                        onChange={(event) => onFieldChange("price", event.target.value)}
                        fullWidth
                        inputMode="decimal"
                        inputProps={{ step: "0.01", min: "0" }}
                    />
                    <TextField
                        select
                        label="Steuersatz (%)"
                        value={newArticle.taxRate}
                        onChange={(event) => onFieldChange("taxRate", event.target.value)}
                        fullWidth
                    >
                        {[19, 7, 0].map((rate) => (
                            <MenuItem key={rate} value={rate}>
                                {rate}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Brutto-Preis"
                        value={
                            newArticle.price
                                ? (toNum(newArticle.price) * (1 + toNum(newArticle.taxRate) / 100)).toFixed(2)
                                : ""
                        }
                        fullWidth
                        disabled
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} color="inherit">
                    Abbrechen
                </Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    sx={{ bgcolor: "orange", "&:hover": { bgcolor: "#cc7a00" }, borderRadius: 2, color: "#000" }}
                >
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}
